<div *ngIf="!dashboard">
  <app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'TASKS'" [breadcrumb]="breadcrumb"
    [isStringLiteral]="stringLiteralBreadcrumb" [count]="total" icon="fa-tasks">
  </app-breadcrumb>
</div>
<div class="content-background">
  <div class="row">
    <div class="col-sm-12">
      <div class="inputWithIcon inputWithIcon-search float-right d-flex">
        <app-advanced-mode id="taskGridAutoCollapseSwitch" [storageKey]="'tasks-list-collapse'"
          [titleKey]="'AUTO-COLLAPSE'" (toggleCcollapsibleTogglehange)="enableAutoCollapse=$event" class="mr-4">
        </app-advanced-mode>
        <app-advanced-mode id="taskGridAdvancedSwitch" [storageKey]="'tasks-list'"
          (collapsibleToggle)="enableAdvanced=$event">
        </app-advanced-mode>
        <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-TASK' | translate }}"
          (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-TASK' | translate }}" />
        <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
      </div>
    </div>
  </div>
  <div class="mt-3" (resized)="onResized($event)">
    <kendo-grid #grid *ngIf="columnsConfig && columnsConfig.length > 0" id="task-list" [data]="gridView"
      [pageable]="isRestrictedPaging ? true : (total > state.take ? { buttonCount: 5, pageSizes: pageSizes } : false)"
      [pageSize]="state.take" [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter"
      [sortable]="true" [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
      [reorderable]="enableAdvanced" [navigable]="true" [kendoGridSelectBy]=""
      (dataStateChange)="dataStateChange($event)" (cellClick)="onCellClick($event)" [selectable]="{ mode: 'single' }"
      [rowClass]="rowCallback" [kendoGridExpandDetailsBy]="expandDetailsBy" [isDetailExpanded]="isTaskDetailExpanded"
      [(expandedDetailKeys)]="expandedDetailKeys" (columnVisibilityChange)="onVisibilityChange($event)"
      (columnResize)="onResize($event)" (columnReorder)="onReorder($event)" (pageChange)="pageChange($event)">
      <kendo-grid-messages noRecords="{{ 'NO-TASKS' | translate }}">
      </kendo-grid-messages>
      <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
        <button kendoButton (click)="refresh()" class="float-right">{{'GRID-REFRESH' | translate }}<i
            class="far fa-sync-alt mt-1"></i>
        </button>
        <button kendoButton (click)="resetGridColumns()" class="float-right">{{'RESET-GRID-COLUMNS' | translate }}
        </button>
        <button *ngIf="!dashboard" kendoButton (click)="filterDialogOpened=true">{{ 'SAVE-FILTER' | translate }}
        </button>
      </ng-template>
      <kendo-grid-column *ngFor="let col of columnsConfig" [field]="col.field" [title]="col.title" [width]="col.width"
        [format]="col.format" [filterable]="col.filterable !== undefined ? col.filterable : true" [filter]="col.filter"
        [sortable]="col.sortable !== undefined ? col.sortable : true"
        [columnMenu]="col.columnMenu !== undefined ? col.columnMenu : true"
        [class]="col.class !== undefined ? (col.class + ' grid-column-'+col.field.replace('.','-')) : 'grid-column-'+col.field.replace('.','-')"
        [hidden]="col.hidden !== undefined ? col.hidden : false">
        <!--name-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'name'">
          <span title="{{dataItem.name}}" class="ellipsis-text-4">{{dataItem.name}}</span>
        </ng-template>
        <!--caseName-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'caseName'">
          <a *ngIf="dataItem?.caseId > 0" [routerLink]="['/case', dataItem.caseId]" class="pointer">
            {{ dataItem.caseName }}
          </a>
          <a *ngIf="dataItem?.caseId === 0 && dataItem?.memberId > 0" [routerLink]="['/patient', dataItem.memberId]"
            class="pointer">
            {{ dataItem.caseName }}
          </a>
          <span *ngIf="dataItem?.caseId === 0 && dataItem?.memberId === 0">{{ dataItem.caseName }}</span>
        </ng-template>
        <!--channel-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'channel'">
          <a *ngxPermissionsOnly="['ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD']" title="{{dataItem.channel}}"
            [routerLink]="['/channel-detail', dataItem.channelId]" class="pointer ellipsis-text-2">
            {{ dataItem.channel }}
          </a>
          <span *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR']">{{ dataItem.channel }}</span>
        </ng-template>
        <!--assigneeName-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'assigneeName'">
          {{dataItem.assigneeName}}
          <a *ngxPermissionsOnly="['ROLE_OPERATOR','ROLE_PROGRAM_LEAD']" class="pointer float-right"
            title="{{'REASSIGN' | translate}}" (click)="openTaskAssigneeDialog(dataItem)" tabindex="0"
            (keydown.enter)="openTaskAssigneeDialog(dataItem)" (keydown.space)="openTaskAssigneeDialog(dataItem)">
            <i *ngIf="dataItem.status === 'Open'" class="fas fa-undo icon-info"
              attr.aria-label="{{'REASSIGN' | translate}}"></i>
          </a>
        </ng-template>
        <!--openedOn-->
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field === 'openedOn'">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
          </kendo-grid-date-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'openedOn'">
          <span>{{intl.formatDate(intl.parseDate(dataItem.openedOn), "g")}}</span>
        </ng-template>
        <!--closedOn-->
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field === 'closedOn'">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
            <kendo-filter-isnull-operator></kendo-filter-isnull-operator>
            <kendo-filter-isnotnull-operator></kendo-filter-isnotnull-operator>
          </kendo-grid-date-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'closedOn'">
          <span>{{intl.formatDate(intl.parseDate(dataItem.closedOn), "g")}}</span>
        </ng-template>
        <!--dueDate-->
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field === 'dueDate'">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
            <kendo-filter-isnull-operator></kendo-filter-isnull-operator>
            <kendo-filter-isnotnull-operator></kendo-filter-isnotnull-operator>
          </kendo-grid-date-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'dueDate'">
          <span>{{intl.formatDate(intl.parseDate(dataItem.dueDate), "d")}}</span>
          <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'EDIT' | translate}}"
            (click)="openTaskDueDateDialog(dataItem);" tabindex="0" (keydown.enter)="openTaskDueDateDialog(dataItem)"
            (keydown.space)="openTaskDueDateDialog(dataItem)">
            <i class="fas fa-undo icon-info" attr.aria-label="{{'EDIT' | translate}}"></i>
          </a>
        </ng-template>
        <!--daysOnList-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'daysOnList'">
          <span *ngIf="dataItem.dueDate && dataItem.overdueDays">
            <span *ngIf="dataItem.overdueDays.length >= 25">
              <i *ngFor="let i of counter(25)" class="fas fa-circle overdue fa-xs">&nbsp;</i>
            </span>
            <span
              *ngIf="dataItem.overdueDays.length < 25 && (dataItem.goodDays.length + dataItem.unusedDays.length + dataItem.goodDays.length) < 25">
              <i *ngFor="let d of dataItem.goodDays" class="fas fa-circle good fa-xs">&nbsp;</i>
              <i *ngFor="let d of dataItem.unusedDays" class="far fa-circle good fa-xs">&nbsp;</i>
              <i
                [className]="(dataItem.days >= dataItem.targetDays ? 'fas fa-circle warning fa-xs' : 'far fa-circle warning fa-xs')">&nbsp;</i>
              <i *ngFor="let d of dataItem.overdueDays" class="fas fa-circle overdue fa-xs">&nbsp;</i>
            </span>
            <span
              *ngIf="dataItem.overdueDays.length < 25 && (dataItem.overdueDays.length + dataItem.goodDays.length) > 25">
              <i *ngFor="let i of counter(24 - dataItem.overdueDays.length)" class="fas fa-circle good fa-xs">&nbsp;</i>
              <i
                [className]="(dataItem.days >= dataItem.targetDays ? 'fas fa-circle warning fa-xs' : 'far fa-circle warning fa-xs')">&nbsp;</i>
              <i *ngFor="let d of dataItem.overdueDays" class="fas fa-circle overdue fa-xs">&nbsp;</i>
            </span>
            <span
              *ngIf="dataItem.overdueDays.length < 25 && (dataItem.overdueDays.length + dataItem.goodDays.length) < 25 && (dataItem.goodDays.length + dataItem.goodDays.length + dataItem.unusedDays.length) > 25">
              <i *ngFor="let d of dataItem.goodDays" class="fas fa-circle good fa-xs">&nbsp;</i>
              <i *ngFor="let i of counter(24 - dataItem.overdueDays.length - dataItem.goodDays.length)"
                class="far fa-circle good fa-xs">&nbsp;</i>
              <i
                [className]="(dataItem.days >= dataItem.targetDays ? 'fas fa-circle warning fa-xs' : 'far fa-circle warning fa-xs')">&nbsp;</i>
              <i *ngFor="let d of dataItem.overdueDays" class="fas fa-circle overdue fa-xs">&nbsp;</i>
            </span>
          </span>
          <span *ngIf="!dataItem.dueDate">
            <span *ngIf="dataItem.goodDays.length <= 25 ">
              <i *ngFor="let d of dataItem.goodDays" class="fas fa-circle good fa-xs">&nbsp;</i>
            </span>
            <span *ngIf="dataItem.goodDays.length > 25 ">
              <i *ngFor="let i of counter(25)" class="fas fa-circle good fa-xs">&nbsp;</i>
            </span>
          </span>
          <span *ngIf="dataItem.days <= 25">{{ dataItem.days}}</span>
          <span *ngIf="dataItem.days > 25" title="{{dataItem.days}} {{'IN-DAYS' |
          translate}}" class="pointer">25+</span>
        </ng-template>
        <!--eventType-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'eventType'">
          <i title="{{dataItem.eventTypeText}} - {{dataItem.event}}" *ngIf="dataItem.eventType"
            [className]="dataItem.eventTypeIcon"></i>
        </ng-template>
        <!--priority-->
        <ng-template kendoGridFilterCellTemplate let-filter *ngIf="col.field === 'priority'">
          <app-dropdown-filter [filter]="filter" [data]="distinctPriorities" filterField="priority"
            textField="priorityName" valueField="priority" selectDefaultText="{{ 'SELECT-PRIORITY' | translate }}">
          </app-dropdown-filter>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'priority'">
          <div [className]="dataItem.priorityBadgeClass">
            {{ dataItem.priority.charAt(0) }}</div>
          <div class="change-icon">
            <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'EDIT' | translate}}"
              (click)="openTaskPriorityDialog(dataItem);" tabindex="0"
              (keydown.enter)="openTaskPriorityDialog(dataItem)" (keydown.space)="openTaskPriorityDialog(dataItem)">
              <i class="fas fa-undo icon-info"></i>
            </a>
          </div>
        </ng-template>
      </kendo-grid-column>
      <ng-template kendoGridDetailTemplate let-dataItem>
        <!-- task detail -->
        <app-task-detail [showDetails]="showDetails" [task]="dataItem" (completed)="onTaskCompleted()"
          (assigneeUpdated)="assigneeUpdated($event)" [isDialog]="false" [gridContainerWidth]="gridContainerWidth">
        </app-task-detail>
      </ng-template>
      <ng-template kendoPagerTemplate *ngIf="isRestrictedPaging">
        <kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
      </ng-template>
    </kendo-grid>
  </div>
</div>

<!-- task assignment dialog -->
<app-task-assign [task]="task" [dialogOpened]="assigneeDialogOpened" (closing)="closeTaskAssigneeDialog();"
  (save)="updateTaskAssignee($event)">
</app-task-assign>

<!-- save filter dialog -->
<app-save-filter [dialogOpened]="filterDialogOpened" [filterCategory]="'Task'" [filterState]="state"
  [filterColumns]="columnsConfig" (cancelling)="filterDialogOpened=false;" [filter]="filterSelected">
</app-save-filter>

<!-- duedate task dialog -->
<app-task-duedate [task]="task" [dialogOpened]="taskDueDateOpened" (closing)="closeTaskDueDateDialog()"
  (save)="updateTaskDueDate($event)">
</app-task-duedate>

<!-- reassign task dialog -->
<app-task-priority [task]="task" [dialogOpened]="priorityDialogOpened" (closing)="closeTaskPriorityDialog();"
  (save)="updateTaskPriority($event)">
</app-task-priority>